import React, { Component } from 'react';
import {
    Modal,
    Button,
    Input,
    TimePicker,
    Row,
    Col,
    message,
    DatePicker,
    Select
} from 'antd';
import moment from 'moment';
import client from 'features/userManage/api/client'
import _ from 'lodash';
import { Message } from 'semantic-ui-react';

const Option = Select.Option;
const _createUIOptions = codes => {
    return codes.map(c => (
        <Option key={c.userAccountId || 'default'} value={c.userAccountId}>
            {c.englishName}
        </Option>
    ));
};

class AddClockModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            japanUserList: [],
            data: { clockDate: moment() },
            errors: []
        }
    }

    componentDidMount() {
        this.getJapanUserList();
    }

    getJapanUserList = () => {
        client.getJapanUserList().catch(err => {
            message.error(err);
        }).then((res) => {
            this.setState({ japanUserList: res?res:[] });
        })
    }

    _applyDataChange = ({ name, value }) => {
        const { data } = this.state;
        this.setState({
            data: {
                ...data,
                [name]: value
            }
        });
    }

    _createErrorPannel = () => {
        const { errors } = this.state;
        return (_.isEmpty(errors) ? ("") :
            (
                <Message error list={errors} style={{ marginBottom: '3px' }} />
            )
        )
    }

    _validate = () => {
        const { clockDate, clockIn, clockOut, userAccountId, remark } = this.state.data;
        const erros = [];
        if(!clockDate) {
            erros.push('Clock Date is required.')
        }
        if(!userAccountId) {
            erros.push('User is required.')
        }
        if(!clockIn && !clockOut) {
            erros.push('Clock In or Clock Out is required.')
        }
        if (_.isEmpty(remark)) {
            erros.push('Remark is required.')
        } 
        this.setState({ errors: erros });
        return _.isEmpty(erros);
    }

    _submitApplyData = () => {
        const { japanUserList } = this.state;
        const { clockDate, clockIn, clockOut, userAccountId, remark } = this.state.data;
        if (!this._validate()) {
            return;
        }

        const userName = _.findLast(japanUserList, { userAccountId }).englishName
        const clockDateStr = clockDate.format('YYYY-MM-DD');
        const clockInStr = clockIn ? clockIn.format('HH:mm:ss') : null;
        const clockOutStr = clockOut ? clockOut.format('HH:mm:ss') : null;

        const datas = [];
        if (clockInStr) {
            datas.push({
                type: 'ClockIn',
                status: 'PASS',
                clockDate,
                userAccountId,
                createdBy: userName,
                remark,
                createdOn: `${clockDateStr} ${clockIn.format('HH:mm:ss')}`
            })
        }
        if (clockOutStr) {
            datas.push({
                type: 'ClockOut',
                status: 'PASS',
                clockDate,
                userAccountId,
                createdBy: userName,
                remark,
                createdOn: `${clockDateStr} ${clockOut.format('HH:mm:ss')}`
            })
        }
        if (!_.isEmpty(datas)) {
            this.props.submitData(datas)
        } else {
            message.info('No need submit.');
        }
    }

    _closeModal = () => {
        this.props.closeModal();
    }

    render() {
        const { data } = this.state;
        return (
            <Modal
                size="large"
                visible={true}
                title={`Add Clock`}
                width={450}
                style={{ height: 150 }}
                bodyStyle={{ paddingTop: '5px' }}
                footer={[
                    <Button size="small" type="primary"
                        onClick={() => { this._submitApplyData() }}>
                        Submit
                    </Button>,
                    <Button size="small" type="primary"
                        onClick={() => { this._closeModal() }}>
                        Close
                    </Button>
                ]}
                closable={false}
            >
                <div>
                    <Row gutter={24}>
                        <Col span={5}><b>Date: </b></Col>
                        <Col span={18}>
                            <DatePicker defaultValue={data.clockDate}
                                format={'YYYY-MM-DD'}
                                size="small"
                                onChange={(value) => {
                                    this._applyDataChange({ name: 'clockDate', value });
                                }}
                                style={{ width: '100%' }} /></Col>
                        <Col span={5}><b>User: </b></Col>
                        <Col span={18}>
                            <Select
                                value={this.state.userAccountId}
                                size='small'
                                showSearch
                                style={{width: '100%'}}
                                onChange={(value) => {
                                    this._applyDataChange({ name: 'userAccountId', value });
                                }}
                            >
                                {_createUIOptions(this.state.japanUserList)}
                            </Select></Col>
                        <Col span={5}><b>ClockIn: </b></Col>
                        <Col span={18}><TimePicker size="small"
                            style={{ width: '100%' }}
                            value={data.clockIn} onChange={(value) => {
                                this._applyDataChange({ name: 'clockIn', value });
                            }} /></Col>
                        <Col span={5}><b>ClockOut: </b></Col>
                        <Col span={18}><TimePicker size="small"
                            style={{ width: '100%' }}
                            value={data.clockOut} onChange={(value) => {
                                this._applyDataChange({ name: 'clockOut', value });
                            }} /></Col>
                        <Col span={5}><b>Remark: </b></Col>
                        <Col span={18}><Input size="small"
                            style={{ width: '100%', marginTop: '3px' }}
                            value={data.remark}
                            placeholder='Please input remark' onChange={(e) => {
                                this._applyDataChange({ name: 'remark', value: e.target.value });
                            }} /></Col>
                    </Row>
                    {this._createErrorPannel()}
                </div>
            </Modal>
        );
    }
}

export default AddClockModal;
